export default {
  settings: {
    module: "module_aval",
    path: "/news",
    routing: [
      {
        id: "map",
        icon: "map",
        route: "/map",
        text_ru: "карта",
        disabled: false
      },
      {
        id: "pulse",
        icon: "pulse",
        route: "/pulse",
        text_ru: "пульс",
        disabled: false
      },
      {
        id: "news",
        icon: "news",
        route: "/news",
        text_ru: "новости",
        disabled: false
      },
      {
        id: "analytics",
        icon: "analytics",
        route: "/country-data/analytics",
        active: "/country-data",
        text_ru: "аналитика",
        disabled: false
      },
      {
        id: "sources",
        icon: "sources",
        route: "/project-sources",
        active: "/project-sources",
        text_ru: "источники",
        disabled: false
      },
    ],
  },
  themesAlwaysEnabled: true,
};
